import React, { useCallback, useMemo, useState } from 'react'
import { Modal } from 'components/Utility/Modal/Modal'
import { ShadowInput } from 'components/FormElements/ShadowInput/ShadowInput'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import styles from './NotificationDialog.module.scss'

const MAX_HOURS = 24

type NotificationDialogProps = {
  isOpen: boolean,
  onClose: () => void,
  /** Hours before the visit */
  onSubmit: (hours: number) => void,
}

/** Asks how many hours before the visit to send a reminder */
export const NotificationDialog: React.FC<NotificationDialogProps> = ({ isOpen, onClose, onSubmit }) => {
  const [value, setValue] = useState(String(MAX_HOURS))

  /** [invalid, message] */
  const error = useMemo((): [boolean, string?] => {
    if (!/^[0-9]+$/.test(value)) {
      return [true]
    }
    if (Number(value) > MAX_HOURS) {
      return [true, 'Максимум - 24 часа']
    }
    if (Number(value) < 1) {
      return [true, 'Минимум 1 час']
    }
    return [false]
  }, [value])

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault()
    if (!error[0]) {
      onSubmit(Number(value))
    }
  }, [onSubmit, value, error])

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.modal} title={'Напомнить о записи'} center>
      <form onSubmit={handleSubmit} className={styles.container}>
        <div className={styles.inputContainer}>
          <div className={styles.prefix}>
            за
          </div>
          <ShadowInput
            error={error[0]}
            value={value}
            onChange={setValue}
            inputMode={'numeric'}
            className={styles.input}
            tooltip={error[1]}
          />
          <div className={styles.suffix}>
            часа
          </div>
        </div>
        <AppButton type={'submit'}>
          Ок
        </AppButton>
      </form>
    </Modal>
  )
}
